module.exports = __webpack_public_path__ + "img/logo3.cc37361d.png";